var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageLoader',{ref:"loader"},[[_c('HostedPaymentPageEditor',{attrs:{"hppData":_vm.hppData,"id":_vm.id}})]],2),_c('LoadingModal',{attrs:{"loadingText":_vm.loadingText,"showModal":_vm.isSubmitting}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }